export const reportPreferenceRecoveryMessage =
  'Попередній вибір полів непридатний. Виберіть поля заново та натисніть «Зберегти». До успішного збереження перегляд, друк і відправка заблоковані.';

export function reportPreferenceRecovery(error: unknown, template: string, channel: string):
  { version: number; businessRevenueAllowed: boolean } | null {
  if (typeof error !== 'object' || error === null || !('response' in error)) return null;
  const response = (error as { response?: { status?: number; data?: {
    code?: string; template?: string; channel?: string; version?: number; businessRevenueAllowed?: boolean;
  } } }).response;
  const data = response?.data;
  if (response?.status !== 409 || data?.code !== 'report-fields-invalid' ||
      data.template !== template || data.channel !== channel ||
      !Number.isSafeInteger(data.version) || data.version == null || data.version < 1) return null;
  return { version: data.version, businessRevenueAllowed: data.businessRevenueAllowed === true };
}
